import { render, staticRenderFns } from "./AddNewPreReceivePurchasing.vue?vue&type=template&id=46965e38&"
import script from "./AddNewPreReceivePurchasing.vue?vue&type=script&lang=js&"
export * from "./AddNewPreReceivePurchasing.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports